import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as customerTypes from "../../../data/booking/constants/customer_types";
import {PageLoader} from "../../shared/components/PageLoader";
import HomeBusiness from "../../account/components/HomeBusiness";
import HomeCustomer from "../../account/components/HomeCustomer";


export default function Home() {
    const {isFetching, data} = useSelector(state => state.account.userSession)

    if(isFetching){
        return <PageLoader />
    }
    if (data && customerTypes.BUSINESS === data.type) {
        return <HomeBusiness />;
    } else {
        return <HomeCustomer />;
    }
}
